import React from 'react'

import { Switch, Tooltip } from '../../../module'
import { IconAndName, type MenuActionPropsWithToggle } from '../Menu'
import styles from '../_menu.module.scss'

type MenuToggleRowProps = MenuActionPropsWithToggle & {
  className: string
  close?: () => void
  /** Optional prop to add a test id to the MenuToggleRow for QA testing */
  qaTestId?: string
}

const MenuToggleRow = (props: MenuToggleRowProps): React.JSX.Element => {
  const { disabled, qaTestId } = props

  return disabled?.tooltip ? (
    <div>
      <Tooltip
        tooltipContent={disabled?.tooltip?.tooltipContent}
        position={disabled?.tooltip?.position ?? 'bottom'}
        qaTestId={qaTestId}
      >
        <MainContent {...props} />
      </Tooltip>
    </div>
  ) : (
    <MainContent {...props} />
  )
}

export default MenuToggleRow

const MainContent = ({
  className = '',
  icon,
  text,
  toggle,
  disabled,
  close,
  qaTestId,
}: MenuToggleRowProps): React.JSX.Element => {
  return (
    <div className={`${className} ${styles.menuRow}`} qa-test-id={qaTestId}>
      <IconAndName icon={icon} text={text} />
      <Switch
        checked={toggle.checked}
        callout={(value) => {
          toggle.callout(value)
          close?.()
        }}
        disabled={disabled?.value}
      />
    </div>
  )
}
